import React, { useEffect, useMemo, useState } from 'react'
import { FieldTargetType, FieldType, TRequestResponse } from '../context/types'
import { useCustomFieldsContext } from '../context/customFields'
import { useAuthContext } from '../context/auth'
import EEOInfo from '../components/helpers/EEOInfo/EEOInfo'
// import Availability from '../components/private/onboarding/Availability/Availability'
import OnboardingCustomFields from '../components/private/onboarding/OnboardingCustomFIelds/OnboardingCustomFields'
import WelcomeMember from '../components/private/onboarding/WelcomeMember/WelcomeMember'
import { useBrandContext } from '../context/brand'
import { useIntegrationContext } from '../context/integration'

export type TStep = {
	component: (props?: any) => JSX.Element
	onSubmit: (values?: any) => Promise<TRequestResponse>
	skippable?: boolean
	title: string
	modalTitle?: string
	stepTitleClass?: string
	customFields?: boolean
	isIntegrationStep?: boolean
}

const useOnboardingSteps = () => {
	const [steps, setSteps] = useState<TStep[]>([])
	const { customFields, actions } = useCustomFieldsContext()
	const { auth, actions: authActions } = useAuthContext()
	const { brand } = useBrandContext()
	const { integration } = useIntegrationContext()

	// const onAvailabilitySubmit = useCallback(async () => {
	// 	const saveButton: HTMLButtonElement = document.querySelector('.AvailabilityViewer__submit')
	// 	saveButton.click()
	// 	return authActions.cronofyFilled()
	// }, [])
	const eeoStep: TStep = {
		title: 'More About You',
		skippable: true,
		component: (props?: any) => <EEOInfo {...props} />,
		onSubmit: authActions.updateEEO,
	}

	const firstIntegrationStep: TStep = useMemo(
		() =>
			integration.onboarding?.first_step
				? {
						title: integration.onboarding.first_step.subtitle,
						modalTitle: integration.onboarding.first_step.title,
						skippable: true,
						component: () => (
							<div
								className="integration-onboarding"
								dangerouslySetInnerHTML={{ __html: integration.onboarding.first_step.content }}
							/>
						),
						isIntegrationStep: true,
						onSubmit: () => Promise.resolve({ ok: true }),
				  }
				: null,
		[integration.onboarding?.first_step]
	)

	const getMemberSteps = (): TStep[] => {
		const customFieldStep: TStep = {
			title: 'How can we best support you?',
			skippable: true,
			stepTitleClass: 'long-step-title',
			component: (props?: any) => <OnboardingCustomFields {...props} />,
			onSubmit: actions.updateCustomFields,
			customFields: true,
		}

		return [
			...(firstIntegrationStep ? [firstIntegrationStep] : []),
			{
				title: 'Welcome',
				modalTitle: `Welcome to <span style="text-transform:none;">${
					brand.currentBrand?.name || ''
				}</span>! We’d like to know more about you so we can match you with the right experts.`,
				skippable: true,
				component: (props?: any) => <WelcomeMember {...props} />,
				onSubmit: authActions.updateOnboardingData,
			},
			...(customFields[FieldTargetType.onboarding].loaded ? [customFieldStep] : []),
			...(integration.onboarding?.eeo !== false ? [eeoStep] : []),
		]
	}

	const getExpertSteps = () => {
		const customFieldStep: TStep = {
			title: 'Your Expertise',
			modalTitle:
				customFields[FieldTargetType.onboarding].loaded &&
				customFields[FieldTargetType.onboarding].fields[0]?.type === FieldType.label
					? null
					: 'What type of advice are you interested in' + ' giving?',
			skippable: true,
			component: (props?: any) => <OnboardingCustomFields {...props} />,
			onSubmit: actions.updateCustomFields,
			customFields: true,
		}

		return [
			...(firstIntegrationStep ? [firstIntegrationStep] : []),
			...(customFields[FieldTargetType.onboarding].loaded ? [customFieldStep] : []),
			...(integration.onboarding?.eeo !== false ? [eeoStep] : []),
			// {
			// 	title: 'Availability',
			// 	skippable: true,
			// 	component: (props?: any) => <Availability {...props} />,
			// 	onSubmit: onAvailabilitySubmit,
			// },
		]
	}

	useEffect(() => {
		setSteps(
			integration.isInviteExpert || (!integration.name && auth.user?.isExpert) ? getExpertSteps() : getMemberSteps()
		)
	}, [customFields, auth.user, integration, firstIntegrationStep])

	return steps
}

export default useOnboardingSteps
